// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__HfPtt","button":"style_button__l1o2H","buttonActive":"style_buttonActive__gOHWG"};